/*LIBRARY*/
import { connect } from "react-redux";
import { useState, useRef } from "react";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import CheckBoxNew from "../common_input/CheckBoxNew";
import SELECTION_REF from "./SELECTION_REF";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SET_AT = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //local storage
  const language = localStorage?.language || auth?.language;

  //state & ref
  const array_templates_ref = useRef(null);
  const should_focus_ref = useRef(false);
  const csv_file_ref = useRef(null); // Ref for file input

  const [modal_selection_ref, set_modal_selection_ref] = useState(false);

  //global props
  const { layer_id, geo_layer_list } = layer;
  const { field_editable } = properties;

  //variable
  const array_templates = field_editable?.array_templates || [];
  const parent_array_templates_key = field_editable?.parent_array_templates_key;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id,
  )?.geo_layer;
  const fields = geo_layer?.fields || [];
  let parent_field;
  let opsi_parent_array = [];
  if (parent_array_templates_key) {
    parent_field = fields.find(
      (item) => item.key === parent_array_templates_key,
    );
    opsi_parent_array = parent_field?.array_templates || [];
  }

  //functions
  const handle_add_array_template = () => {
    should_focus_ref.current = true;
    array_templates.push({
      name: "",
      parent: "",
    });
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        array_templates,
      },
    });
    setTimeout(() => {
      if (array_templates_ref.current) {
        array_templates_ref.current.scrollTop =
          array_templates_ref.current.scrollHeight;
      }
    }, 0);
  };

  const handle_upload_csv = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split("\n").filter((line) => line.trim() !== "");

      if (lines.length === 0) return;

      let delimiter = ",";
      if (lines[0].includes(";")) {
        delimiter = ";";
      }

      const headers = lines[0].split(delimiter).map((header) => header.trim());

      if (headers.length < 1) {
        alert("CSV must contain at least one column for the main name.");
        event.target.value = null;
        return;
      }

      // Kolom pertama adalah nama utama (child/name)
      const name_index = 0;
      // Kolom kedua adalah parent (jika ada)
      const parent_index = headers.length > 1 ? 1 : -1;

      const new_array_templates = [];

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(delimiter);
        const item_name = values[name_index]?.trim() || "";
        const parent_name =
          parent_index !== -1 ? values[parent_index]?.trim() || "" : "";

        if (item_name) {
          new_array_templates.push({
            name: item_name,
            parent: parent_name,
          });
        }
      }

      if (new_array_templates.length > 0) {
        set_value_properties({
          key: "field_editable",
          value: {
            ...field_editable,
            array_templates: new_array_templates,
          },
        });
      }

      event.target.value = null;
    };

    reader.readAsText(file);
  };

  const handle_download_csv_example = () => {
    let csv_content = "";
    if (field_editable?.is_use_parent_array_template) {
      csv_content = "Child;Parent\n";
      csv_content += "Item A;Group One\n";
      csv_content += "Item B;Group One\n";
      csv_content += "Item C;Group One\n";
      csv_content += "Item D;Group Two\n";
      csv_content += "Item E;Group Two\n";
      csv_content += "Item F;Group Two";
    } else {
      csv_content = "Nilai\n";
      csv_content += "Rendah\n";
      csv_content += "Sedang\n";
      csv_content += "Tinggi";
    }
    const blob = new Blob([csv_content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "array_templates_example.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const modal_selection_ref_content = modal_selection_ref && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_selection_ref}
      onClose={() => {
        set_modal_selection_ref(false);
      }}
    >
      <SELECTION_REF set_modal_selection_ref={set_modal_selection_ref} />
    </Modal>
  );

  return (
    <main>
      {modal_selection_ref_content}
      <p className="text_medium sub_color">
        {dict?.["Fill option values"]?.[language]}
      </p>
      <section className="two_container_auto margin_bottom">
        <CheckBoxNew
          title={dict?.["Use the reference column"]?.[language]}
          value={field_editable?.is_use_parent_array_template}
          handle={() => {
            if (!field_editable?.is_use_parent_array_template) {
              set_modal_selection_ref(true);
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  is_use_parent_array_template: true,
                },
              });
            } else {
              set_value_properties({
                key: "field_editable",
                value: {
                  ...field_editable,
                  parent_array_templates_key: "",
                  is_use_parent_array_template: false,
                },
              });
            }
          }}
        />
        <div className="text_right">
          {parent_field?.key && (
            <p
              className="badge background_white cursor_pointer"
              onClick={() => {
                set_modal_selection_ref(true);
              }}
            >
              {parent_field?.name}
            </p>
          )}
        </div>
      </section>

      <section className="container background_white margin_bottom">
        <div className="two_container_equal margin_bottom">
          <div>
            <input
              type="file"
              accept=".csv"
              ref={csv_file_ref}
              style={{ display: "none" }}
              onChange={handle_upload_csv}
            />
            <button
              className="button button_white outline_grey"
              onClick={() => csv_file_ref.current.click()}
            >
              {dict?.["Upload CSV list"]?.[language]}
            </button>
          </div>

          <div className="text_right">
            <button
              className="button button_white outline_grey"
              onClick={handle_download_csv_example}
            >
              {dict?.["CSV Template Standard"]?.[language]}
            </button>
          </div>
        </div>

        {language === "eng" ? (
          <>
            <p className="text_medium sub_color margin_bottom">
              To ensure your data is processed correctly, please download and
              use our{" "}
              <b
                className="text_black cursor_pointer"
                onClick={handle_download_csv_example}
              >
                Standard Template.
              </b>
            </p>

            <p className="text_medium sub_color">
              <b className="text_black">Important:</b> Please do not rename or
              delete the column header, as it is used by the system to identify
              your unique value. Simply list your values (such as names or IDs)
              directly underneath it.
            </p>
          </>
        ) : (
          <>
            <p className="text_medium sub_color margin_bottom">
              Untuk memastikan data Anda diproses dengan benar, silakan unduh
              dan gunakan{" "}
              <b
                className="text_black cursor_pointer"
                onClick={handle_download_csv_example}
              >
                Template Standar
              </b>{" "}
              kami.
            </p>

            <p className="text_medium sub_color">
              <b className="text_black">Penting:</b> Jangan mengubah nama atau
              menghapus header kolom, karena digunakan oleh sistem untuk
              mengidentifikasi nilai. Cukup cantumkan nilai-nilai Anda (seperti
              nama atau ID) langsung di bawahnya.
            </p>
          </>
        )}
      </section>

      <section className="container background_white">
        <section className="margin_bottom">
          {parent_array_templates_key ? (
            <div className="two_container_equal">
              <p className="text_medium">{dict?.["Value"]?.[language]}</p>
              <p className="text_medium text_right">
                {dict?.["Shown if"]?.[language]}
              </p>
            </div>
          ) : (
            <div className="two_container_equal">
              <p className="text_medium">
                {dict?.["Fill-in values"]?.[language]}
              </p>
            </div>
          )}

          <CheckBoxNew
            title={dict?.["Allow other answers"]?.[language]}
            value={field_editable?.isAllowOtherAnswer}
            handle={() => {
              if (!field_editable?.isAllowOtherAnswer) {
                set_value_properties({
                  key: "field_editable",
                  value: {
                    ...field_editable,
                    isAllowOtherAnswer: true,
                  },
                });
              } else {
                set_value_properties({
                  key: "field_editable",
                  value: {
                    ...field_editable,
                    isAllowOtherAnswer: false,
                  },
                });
              }
            }}
          />
        </section>

        <div
          ref={array_templates_ref}
          id="array_templates_input"
          style={{ maxHeight: "277px", overflowY: "auto" }}
        >
          {array_templates.map((item, child_index) => {
            return parent_array_templates_key ? (
              <div key={child_index} className="two_container_auto">
                <input
                  ref={(el) => {
                    if (
                      el &&
                      child_index === array_templates.length - 1 &&
                      should_focus_ref.current
                    ) {
                      setTimeout(() => {
                        el.focus();
                        should_focus_ref.current = false;
                      }, 0);
                    }
                  }}
                  value={item.name}
                  onChange={(event) => {
                    array_templates[child_index].name = event.target.value;
                    set_value_properties({
                      key: "field_editable",
                      value: {
                        ...field_editable,
                        array_templates,
                      },
                    });
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handle_add_array_template();
                    }
                  }}
                />
                <div className="two_container_auto">
                  <select
                    value={item.parent}
                    onChange={(event) => {
                      array_templates[child_index].parent = event.target.value;
                      set_value_properties({
                        key: "field_editable",
                        value: {
                          ...field_editable,
                          array_templates,
                        },
                      });
                    }}
                  >
                    <option>Pilih</option>
                    {opsi_parent_array.map((item, parent_index) => {
                      return (
                        <option key={parent_index} value={item?.name}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                  <div className="text_right">
                    <button
                      className="button_circle_small red_container margin_right"
                      onClick={() => {
                        const updated_array = array_templates.filter(
                          (_, index) => index !== child_index,
                        );
                        set_value_properties({
                          key: "field_editable",
                          value: {
                            ...field_editable,
                            array_templates: updated_array,
                          },
                        });
                      }}
                    >
                      X
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div key={child_index} className="two_container_auto">
                <input
                  ref={(el) => {
                    if (
                      el &&
                      child_index === array_templates.length - 1 &&
                      should_focus_ref.current
                    ) {
                      setTimeout(() => {
                        el.focus();
                        should_focus_ref.current = false;
                      }, 0);
                    }
                  }}
                  className="margin_bottom"
                  value={item.name}
                  onChange={(event) => {
                    array_templates[child_index].name = event.target.value;
                    set_value_properties({
                      key: "field_editable",
                      value: {
                        ...field_editable,
                        array_templates,
                      },
                    });
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handle_add_array_template();
                    }
                  }}
                />
                <div className="text_right">
                  <button
                    className="button_circle_small red_container margin_right"
                    onClick={() => {
                      const updated_array = array_templates.filter(
                        (_, index) => index !== child_index,
                      );
                      set_value_properties({
                        key: "field_editable",
                        value: {
                          ...field_editable,
                          array_templates: updated_array,
                        },
                      });
                    }}
                  >
                    X
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text_center margin_top">
          <button
            className="button_circle background_black text_big"
            onClick={handle_add_array_template}
          >
            +
          </button>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
})(SET_AT);
